import { useEffect } from "react";
import { matchPath, useLocation } from "react-router";

import { useProjectId } from "@/hooks/Network/useProjectId";
import { clearSessionStorage } from "@/hooks/useLocalStorage";
import { ticketStorageKeys } from "@/queries/tickets/filters";
import { routes } from "@/routes";

function clearTicketsStorage(projectId: string): void {
  clearSessionStorage(ticketStorageKeys.residentFocusMode());
  clearSessionStorage(ticketStorageKeys.filters(projectId));
}

// Used for only clearing ticket-related session storage when navigating away from ticket-related pages
export function useClearTicketsCache(): void {
  const projectId = useProjectId();
  const location = useLocation();

  useEffect(() => {
    if (matchPath(routes.tickets.ROOT, location.pathname)) {
      return;
    }

    if (matchPath(routes.ticketCategories.ROOT, location.pathname)) {
      return;
    }

    if (matchPath(routes.ticketStatuses.ROOT, location.pathname)) {
      return;
    }

    if (matchPath(routes.users.details.PATH, location.pathname)) {
      return;
    }

    clearTicketsStorage(projectId);
  }, [location, projectId]);
}
